import { render, staticRenderFns } from "./NewSuppliersGroupForm.vue?vue&type=template&id=ec585e24&scoped=true&"
import script from "./NewSuppliersGroupForm.vue?vue&type=script&lang=js&"
export * from "./NewSuppliersGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec585e24",
  null
  
)

export default component.exports